import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/system";
import ButtonCircular from "src/component/ButtonCircular";
const StyledIndex = styled("Box")(({ theme }) => ({
  "& .root": {
    backgroundColor: "#484e5c",
  },
  "& .MainLayout": {
    minHeight: "calc(100vh - 415px)"
  },
}));
const MainLayout = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  useEffect(() => {
    const logined = window.localStorage.getItem("token")
    const auth = window.localStorage.getItem("auth")
    if (auth && logined) {
      history.push("/employee_dashboard")
    } else {
      history.push("/")
    }
    setLoading(false);
  }, [history])
  return (
    <StyledIndex>
      {loading ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <ButtonCircular />
      </div> : <>
        <div className="root">
          <div
            style={
              history.location.pathname !== "/"
                ? { display: "block" }
                : { display: "none" }
            }
          ></div>
          <div className="MainLayout">{children}</div>
        </div>
      </>}
    </StyledIndex>
  );
};

export default MainLayout;
